import { compareAsc, isAfter, max } from 'date-fns';

export const unionTupleDates = (arrays: [Date, Date][]): [Date, Date][] => {
  const sortedArrays = arrays.sort((a, b) => compareAsc(a[0], b[0]));
  const first = sortedArrays[0];
  const merged: [Date, Date][] = [first];

  sortedArrays.forEach((current) => {
    const lastMerged = merged[merged.length - 1];

    if (!lastMerged || isAfter(current[0], lastMerged[1])) {
      merged.push(current);
    } else {
      lastMerged[1] = max([current[1], lastMerged[1]]);
    }
  });

  return merged;
};
